import {AxiosInstance, AxiosResponse} from 'axios';
import {
    TimeBankBalance,
    TimeBankManualTransactionRequest,
    TimeBankReportEmployee,
    TimeBankTransaction,
} from './types';

export interface ITimeBankApi {
    getBalance(employeeId: number): Promise<AxiosResponse<TimeBankBalance>>;
    getTransactions(employeeId: number, from: string, to: string): Promise<AxiosResponse<TimeBankTransaction[]>>;
    getReport(from: string, to: string, employeeIds: number[]): Promise<AxiosResponse<TimeBankReportEmployee[]>>;
    createManualTransaction(
        employeeId: number,
        request: TimeBankManualTransactionRequest
    ): Promise<AxiosResponse<TimeBankBalance>>;
    deleteManualTransaction(transactionId: number): Promise<AxiosResponse<TimeBankBalance>>;
}

export default class TimeBankApi implements ITimeBankApi {
    private readonly _axiosInstance: AxiosInstance;
    private readonly _controller = 'time-bank';

    constructor(axiosInstance: AxiosInstance) {
        this._axiosInstance = axiosInstance;
    }

    async getBalance(employeeId: number): Promise<AxiosResponse<TimeBankBalance>> {
        return await this._axiosInstance.get<TimeBankBalance>(`${this._controller}/employees/${employeeId}/balance`);
    }

    async getTransactions(employeeId: number, from: string, to: string): Promise<AxiosResponse<TimeBankTransaction[]>> {
        const params = new URLSearchParams({ from, to });
        return await this._axiosInstance.get<TimeBankTransaction[]>(
            `${this._controller}/employees/${employeeId}/transactions?${params.toString()}`
        );
    }

    async getReport(from: string, to: string, employeeIds: number[]): Promise<AxiosResponse<TimeBankReportEmployee[]>> {
        const params = new URLSearchParams({ from, to });
        employeeIds.forEach((employeeId) => params.append('employeeIds', String(employeeId)));

        return await this._axiosInstance.get<TimeBankReportEmployee[]>(
            `${this._controller}/report?${params.toString()}`
        );
    }

    async createManualTransaction(
        employeeId: number,
        request: TimeBankManualTransactionRequest
    ): Promise<AxiosResponse<TimeBankBalance>> {
        return await this._axiosInstance.post<TimeBankBalance>(
            `${this._controller}/employees/${employeeId}/manual-transactions`,
            JSON.stringify(request),
            { headers: { 'Content-Type': 'application/json' } }
        );
    }

    async deleteManualTransaction(transactionId: number): Promise<AxiosResponse<TimeBankBalance>> {
        return await this._axiosInstance.delete<TimeBankBalance>(
            `${this._controller}/manual-transactions/${transactionId}`
        );
    }

}
